import {Component, OnInit, OnDestroy} from '@angular/core';
import {RestApiService} from '../rest-api.service';
import {NotifierService} from 'angular-notifier';
import {Formatters} from 'angular-slickgrid';
import {MessageService} from '../message.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-metadata-user-field',
  templateUrl: './metadata-user-field.component.html',
  styleUrls: ['./metadata-user-field.component.css']
})
export class MetadataUserFieldComponent implements OnInit, OnDestroy {

  displayed = true;
  totalData = 0;
  show: boolean;
  selected: number;
  respObject: any;

  clientSelected: number;
  clients: any[];
  role: any[];
  tables: any[];
  metaTableSelected: number;
  tableName: string;
  roleName: string;
  roleSelected: number;
  actions: any[];
  displayData: any;
  notAdmin = true;
  urlSelected: number;
  urls: any[];
  urlName: string;

  add: boolean;
  del: boolean;
  edit: boolean;
  view: boolean;
  isError = false;
  errorMessage: string;

  private clientName: any;

  private notifier: NotifierService;
  private clientId: any;
  private baseFlag: any;
  tableFields = [];
  users = [];
  tableFieldName: string;
  userSelected: number;
  metaTableFieldSelected: number;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private adminAuth: Subscription;
  dataLoaded:boolean;

  constructor(private _rest: RestApiService, private messageService: MessageService,
              private route: Router, private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      switch (item.type) {
        case 'change':
          // console.log('changed');
          if (!this.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {

          }
          break;
        case 'delete':
          // console.log('deleted');
          if (!this.del && this.baseFlag) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              this._rest.deleteTableFieldUserAction({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                  // this.totalData = this.totalData - 1;
                  // this.messageService.setTotalData(this.totalData);
                  this.messageService.sendAfterDelete(item.id);
                  this.messageService.sendAfterDelete(item.id);
                } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                this.notifier.notify('error', this.respObject.errorMessage);
              });
            }
          }
          break;
      }
    });
    this.messageService.getUserAuth().subscribe(details => {
      // console.log(JSON.stringify(details));
      if (details.length > 0) {
        this.add = details[0].addFlag;
        this.del = details[0].deleteFlag;
        this.view = details[0].viewFlag;
        this.edit = details[0].editFlag;
      } else {
        this.add = false;
        this.del = false;
        this.view = false;
        this.edit = false;
      }
    });
    this.messageService.getSelectedItemData().subscribe(selectedTitles => {
      if (selectedTitles.length > 0) {
        this.show = true;
        this.selected = selectedTitles.length;
      } else {
        this.show = false;
      }
    });
  }

  ngOnInit() {
    this.dataLoaded=false;
      this.nextOffset = 0;
      this.previousOffset = 0;
      this.pageSize = this.messageService.pageSize;
      this.page_no = 0;
      this.totalPage = 0;
      this.paginationType = 'next';
    // this.messageService.setGridWidth(1000);

    this.displayData = {
      pageName: 'Maintain TableField User Action',
      openModalButton: 'Map Action and User With Table Field',
      breadcrumb: 'TableFieldUserAction',
      folderName: 'All Mapped Action and Users with Table Field',
      tabName: 'Table Field User Action Mapping'
    };

    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, maxWidth: 30, filterable: true},
      {
        id: 'client', name: 'Client ', field: 'client', sortable: true, filterable: true
      },
      {
        id: 'role', name: 'Role', field: 'role', sortable: true, filterable: true
      },
      {
        id: 'user', name: 'User', field: 'user', sortable: true, filterable: true
      },
      {
        id: 'table', name: 'Table', field: 'tableName', sortable: true, filterable: true
      },
      {
        id: 'url', name: 'URL', field: 'url', sortable: true, filterable: true
      },
      {
        id: 'tableField', name: 'Table Field ', field: 'tableField', sortable: true, filterable: true
      },
      {
        id: 'action', name: 'Action', field: 'action', sortable: true, filterable: true
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    this._rest.getActions().subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        for (let i = 0; i < this.respObject.actions.length; i++) {
          this.respObject.actions.checked = false;
        }
        this.actions = this.respObject.actions;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
    this._rest.getMetadataTable().subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        // console.log(JSON.stringify(this.respObject));
        this.respObject.details.unshift({id: 0, name: 'Select Table'});
        this.tables = this.respObject.details;
        this.metaTableSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
      if (this.messageService.clientId) {
          this.clientId = this.messageService.clientId;
          this.baseFlag = this.messageService.baseFlag;
          this.onPageLoad();
      } else {
          this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
              if (details.length > 0) {
                  this.add = details[0].addFlag;
                  this.del = details[0].deleteFlag;
                  this.view = details[0].viewFlag;
                  this.edit = details[0].editFlag;
                  this.clientId = details[0].clientId;
                  this.baseFlag = details[0].baseFlag;
                  this.onPageLoad();
              }
          });
      }
  }

    onPageLoad() {
        if (this.baseFlag) {
            this.notAdmin = false;
            this._rest.getClient().subscribe((res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    this.isError = false;
                    this.respObject.clients.unshift({id: 0, name: 'Select Client'});
                    this.clients = this.respObject.clients;
                    this.clientSelected = 0;
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.clientSelected = this.clientId;
            this._rest.getRoleClientWise(this.clientSelected).subscribe((res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    this.isError = false;
                    this.respObject.roles.unshift({id: 0, name: 'Select Role'});
                    this.role = this.respObject.roles;
                    this.roleSelected = 0;
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        }
        this.getTableData();
    }

  openModal(content) {
    if (!this.add && this.baseFlag) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      if (this.baseFlag) {
        this.clientSelected = 0;
      }
      this.roleSelected = 0;
      this.metaTableSelected = 0;
      this.metaTableFieldSelected = 0;
      this.urlSelected = 0;
      this.userSelected = 0;
      this.modalService.open(content, {size: 'sm'}).result.then((result) => {
      }, (reason) => {

      });
    }
  }

  get selectedOptions() {
    return this.actions
      .filter(opt => opt.checked)
      .map(opt => opt.id);

  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  save() {
    const data = {
      clientId: this.clientSelected,
      roleId: this.roleSelected,
      tableId: this.metaTableSelected,
      createdBy: this.messageService.getUserId(),
      actionIds: this.selectedOptions,
        refer_user_id: this.userSelected,
      urlId: this.urlSelected,
      fieldId: this.metaTableFieldSelected
    };
    if (!this.messageService.isBlankField(data) && this.selectedOptions.length > 0) {
      this._rest.mapTableFieldUserAction(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.isError = false;
          if (this.baseFlag) {
            this.clientSelected = 0;
          }
          this.roleSelected = 0;
          this.metaTableSelected = 0;
          this.userSelected = 0;
          this.metaTableFieldSelected = 0;
          this.urlSelected = 0;
          this.nextOffset = 0;
          this.page_no = 0;
          this.getTableData();
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  getTableData() {
    if (!this.view && this.baseFlag) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

  }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded=false;
        this._rest.getTableFieldUserActionMap(offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.respObject.errorMessage);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
          this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.adminAuth) {
            this.adminAuth.unsubscribe();
        }
    }

  onClientChange(value: any) {
    this.clientName = this.clients[value].name;
    this._rest.getRoleClientWise(this.clientSelected).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.roles.unshift({id: 0, name: 'Select Role'});
        this.role = this.respObject.roles;
        this.roleSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  onRoleChange(selectedIndex: any) {
    this.roleName = this.role[selectedIndex].name;
    this._rest.getUserByRole({clientId: this.clientSelected, roleId: this.roleSelected}).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.respObject.details.unshift({id: 0, name: 'Select User'});
        this.users = this.respObject.details;
        this.userSelected = 0;
      } else {
      }
    }, (err) => {

    });
  }

  onTableChange(selectedIndex: any) {
    this.tableName = this.tables[selectedIndex].name;
    this._rest.getFieldByTable(this.metaTableSelected).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.details.unshift({id: 0, name: 'Select Table Fields'});
        this.tableFields = this.respObject.details;
        this.metaTableFieldSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  onTableFieldChange(selectedIndex: any) {
    this.tableFieldName = this.tableFields[selectedIndex].name;
    this._rest.getUrlByTable(this.metaTableSelected).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.details.unshift({id: 0, name: 'Select Url'});
        this.urls = this.respObject.details;
        this.urlSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  onUrlChange(value: any) {
    this.urlName = this.urls[value].name;
    this._rest.getTableFieldUserWiseActions(this.clientSelected, this.roleSelected,
      this.metaTableSelected, this.metaTableFieldSelected, this.urlSelected, this.userSelected).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        if (this.respObject.details.length > 0) {
          for (let i = 0; i < this.respObject.details.length; i++) {
            for (let j = 0; j < this.actions.length; j++) {
              if (this.respObject.details[i].id === this.actions[j].id) {
                this.actions[j].checked = true;
                break;
              }
            }
          }
        } else {
          for (let j = 0; j < this.actions.length; j++) {
            this.actions[j].checked = false;
          }
        }
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  onUserChange(selectedIndex: any) {
    // this.userName = this.users[selectedIndex].name;
  }
}
